import gql from 'graphql-tag'

export default gql`
{
  events
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/events.js